// url listener used for deep linking
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { App, URLOpenListenerEvent } from '@capacitor/app'

// AppUrlListener is a component that listens to the appUrlOpen event for deep linking.
// La mesure d'audience (Google Analytics, Firebase Analytics) a disparu le
// 08/10 : plus aucun traceur tiers, donc plus de bandeau de cookies.
const AppUrlListener: React.FC = () => {
    const history = useHistory()

    useEffect(() => {
        const url = new URL(window.location.href)
        const redirectTo = url.searchParams.get('redirectTo')

        if (redirectTo) {
            localStorage.setItem('pendingRedirect', redirectTo)
        }

        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            if (event.url) {
                if (event.url.includes('com.lk-s.luckysit://home')) {
                    // set to ios
                    history.replace('/')
                } else if (event.url.includes('luckysit://com.lks.luckysit')) {
                    // set to android
                    history.replace('/')
                }
            }
        })
    }, [])

    return null
}

export default AppUrlListener
